var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99665 14C10.8331 14 13.9933 10.8331 13.9933 6.99665C13.9933 3.16021 10.8264 0 6.99665 0C3.16021 0 0 3.16021 0 6.99665C0 10.8331 3.16021 14 6.99665 14ZM6.99665 12.4266C3.99043 12.4266 1.58011 10.0029 1.58011 6.99665C1.58011 3.99044 3.98374 1.57341 6.99665 1.57341C10.0029 1.57341 12.4199 3.99044 12.4266 6.99665C12.4266 10.0029 10.0029 12.4266 6.99665 12.4266ZM6.83596 8.28886C7.23099 8.28886 7.49211 8.07461 7.52559 7.7934C7.53228 7.76662 7.53228 7.73314 7.53898 7.71306C7.57245 7.39168 7.82688 7.16404 8.23529 6.90292C8.90483 6.46772 9.29316 6.08608 9.29316 5.3362C9.29316 4.22477 8.28216 3.55524 7.05021 3.55524C5.90531 3.55524 5.10856 4.05739 4.88092 4.69345C4.83405 4.81396 4.80727 4.93448 4.80727 5.06169C4.80727 5.40316 5.07508 5.63749 5.45002 5.63749C5.85175 5.63749 5.96557 5.43663 6.15304 5.22908C6.36729 4.92109 6.62171 4.74701 6.97657 4.74701C7.44524 4.74701 7.74653 5.01483 7.74653 5.41655C7.74653 5.79149 7.46533 6.00574 6.91631 6.38737C6.44094 6.71545 6.11286 7.05022 6.11286 7.60593V7.67288C6.11286 8.0813 6.36729 8.28886 6.83596 8.28886ZM6.82927 10.3912C7.29794 10.3912 7.66619 10.0765 7.66619 9.62123C7.66619 9.16595 7.29794 8.85127 6.82927 8.85127C6.36059 8.85127 5.98565 9.16595 5.98565 9.62123C5.98565 10.0698 6.36059 10.3912 6.82927 10.3912Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.c1d19ba02262301c409c3d2a540f8a30.svg";
export { ForwardRef as ReactComponent };